import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-students-not-riding",
	templateUrl: "./students-not-riding.component.html",
	styleUrls: ["./students-not-riding.component.css"],
})
export class StudentsNotRidingComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private dialogService: DialogService
	) {}

	report = {
		StartDate: new Date(),
		EndDate: new Date(),
		BusID: 0,
		BusRouteTypeID: 0,
		SortByID: "FirstName",
		SortDirectionID: "ASC",
		SchoolID: 0,
		ImageLogo: "",
	};

	IncludeClosedDays: boolean = false;
	IncludeAbsent: boolean = true;
	IncludeInSchool: boolean = true;

	SchoolSelectShowAllText: string = "All Schools";

	BusList: any = [];
	BusRouteTypeList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Bus",
			Desc: "Bus",
		},
		{
			ID: "Route",
			Desc: "Route",
		},
		{
			ID: "RouteType",
			Desc: "Route Type",
		},
		{
			ID: "School",
			Desc: "School",
		},
		{
			ID: "EntryDate",
			Desc: "Entry Date",
		},
		{
			ID: "AttendanceStatus",
			Desc: "Attendance Status",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 486;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		this.loadBusList();
		this.loadBusRouteTypeList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadLogolist();
	}

	private loadBusList() {
		var result = this.reportService.BusGetList();
		result.subscribe(
			(response) => {
				this.BusList = response;

				this.BusList.unshift({
					BusID: -1,
					BusNbr: "All Buses",
					BusDesc: "All Buses",
				});

				this.report.BusID = this.BusList[0].BusID;
			},
			(error) => {}
		);
	}

	private loadBusRouteTypeList() {
		var result = this.reportService.BusRouteTypeGetList();
		result.subscribe(
			(response) => {
				this.BusRouteTypeList = response;

				this.BusRouteTypeList.unshift({
					BusRouteTypeID: -1,
					BusRouteTypeNbr: "All Route Types",
					BusRouteTypeDesc: "All Route Types",
				});

				this.report.BusRouteTypeID = this.BusRouteTypeList[0].BusRouteTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: BusID
		strParam += "," + this.report.BusID + "|BusID";

		//Parameter 5: BusRouteTypeID
		strParam += "," + this.report.BusRouteTypeID + "|BusRouteTypeID";

		//Parameter 6: IncludeClosedDays
		strParam += "," + (this.IncludeClosedDays == true ? 1 : 0) + "|IncludeClosedDays";

		//Parameter 7: IncludeAbsent
		strParam += "," + (this.IncludeAbsent == true ? 1 : 0) + "|IncludeAbsent";

		//Parameter 8: IncludeInSchool
		strParam += "," + (this.IncludeInSchool == true ? 1 : 0) + "|IncludeInSchool";

		//Parameter 9: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 10: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 11: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 12: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
